import { ErrorAlert } from "@components/ErrorAlert";
import { queriesWorksites } from "@query";
import {
  useWSModalCustom,
  WSForm,
  WSList,
  WSModal,
  WSModalCustomProps
} from "@wingspanhq/fe-component-library";
import { Worksite } from "@wingspanhq/wingspan-api-sdk";
import React from "react";

import { FormPartialWorksite } from "../../components/FormPartialWorksite";
import { selectorWorksiteFormDefaultValues } from "../../selectors/selectorWorksiteFormDefaultValues";
import { selectorWorksiteRequest } from "../../selectors/selectorWorksiteRequest";
import { FormDataWorksite } from "../../types";
import { validationSchemaWorksite } from "../../validationSchemaWorksite";

type Props = {
  /**
   * True while the account has no work site yet. The first one is always the
   * primary, so the flag is pre-checked and the payload carries it regardless.
   */
  isFirstWorksite?: boolean;
} & WSModalCustomProps<Worksite | null>;

const ModalCreateWorksite: React.FC<Props> = props => {
  const [createWorksite, meta] = queriesWorksites.createWorksite.useMutation();

  const handleSubmit = async (formData: FormDataWorksite) => {
    await createWorksite(
      {
        worksiteCreate: {
          ...selectorWorksiteRequest(formData),
          isPrimary: props.isFirstWorksite || formData.isPrimary
        }
      },
      { onSuccess: created => props.onClose(created) }
    );
  };

  return (
    <WSForm<FormDataWorksite>
      defaultValues={{
        ...selectorWorksiteFormDefaultValues(),
        isPrimary: !!props.isFirstWorksite
      }}
      validationSchema={validationSchemaWorksite}
      onSubmit={handleSubmit}
    >
      <WSModal
        size="S"
        title="Create work site"
        onClose={() => props.onClose(null)}
        actions={{
          buttons: [
            {
              label: "Cancel",
              kind: "Secondary",
              type: "button",
              onClick: () => props.onClose(null)
            },
            {
              label: "Create work site",
              type: "submit",
              loading: meta.isLoading
            }
          ]
        }}
      >
        <WSList gap="L">
          <FormPartialWorksite />
          <ErrorAlert context="WorksiteSave" error={meta.error} />
        </WSList>
      </WSModal>
    </WSForm>
  );
};

export const useModalCreateWorksite = () =>
  useWSModalCustom(ModalCreateWorksite);
